import axios from 'axios';
import * as types from '../constants/ActionTypes';

const searchURL = '/smarthelp/related-article';
const defaultTopReasonQuery = 'HELPHUB_TOPCONTACTREASON';
const defaultSize = 5;

export const defaultSearchEnable = () => ({ type: types.DEFAULT_SEARCH_ENABLE });

const setDefaultTopSearchReason = (response) => ({
  type: types.DEFAULT_TOP_SEARCH_REASON,
  payload: response,
});

const setComplaintsFaqs = (response) => ({
  type: types.COMPLAINTS_PAGE_COMMON_QUESTIONS,
  payload: response,
});

const requestDefaultTopReasons = () => ({
  type: types.REQUEST_TOP_CONTACT_REASONS,
});

const defaultTopSearchError = () => ({ type: types.DEFAULT_TOP_SEARCH_REASON_ERROR });

export function inputBoxClick(isFocused) {
  return {
    type: types.SEARCHBAR_INPUTBOX_FOCUS,
    payload: isFocused,
  };
}

// Filter top contact reason response data
const filterSearchResponse = (responseData) => {
  if (!Array.isArray(responseData)) {
    return [];
  }

  return responseData.slice(0, defaultSize)
    .map((article) => ({
      title: article.articleTitle,
      docid: article.articleId,
    }));
};

// Get top contact Reason as default search selection
export const getTopSearchReason = (searchQuery = '', requestFromComplaintsPage = false) => (dispatch) => {
  const defaultSearchQuery = searchQuery || defaultTopReasonQuery;
  dispatch(requestDefaultTopReasons());
  return axios(`${searchURL}?topic=${defaultSearchQuery}`)
    .then((res) => {
      if (!res.data || !res.data.length) {
        // Dispatching error actions when API returns 200 with empty response
        dispatch(defaultTopSearchError());
      } else if (requestFromComplaintsPage) {
        // if request is from complaints page common question update in new state variable
        dispatch(setComplaintsFaqs(res.data));
      } else {
        dispatch(setDefaultTopSearchReason(filterSearchResponse(res.data)));
      }
    })
    .catch(() => {
      dispatch(defaultTopSearchError());
    });
};
// SHOW_TOP_CONTACT_REASON showing the faqs
export const showTopReason = () => ({ type: types.SHOW_TOP_CONTACT_REASON });

export const hideTopReason = () => ({ type: types.HIDE_TOP_CONTACT_REASON });

export function onFocusOfInputBox(isFocused) {
  return (dispatch) => {
    dispatch(inputBoxClick(isFocused));
  };
}
